import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  return {
    yourInformationHeader: formatMessage(messages.yourInformationHeader),
    emailLabel: formatMessage(messages.emailLabel),
    phoneNumberLabel: formatMessage(messages.phoneNumberLabel),
    additionalPhoneLabel: formatMessage(messages.additionalPhoneLabel),
    addAdditionalPhone: formatMessage(messages.addAdditionalPhone),
    selectPatientHeader: formatMessage(messages.selectPatientHeader),
    selectButton: formatMessage(messages.selectButton),
    addAnotherPatient: formatMessage(messages.addAnotherPatient),
    requiresGuardian: formatMessage(messages.requiresGuardian),
    patientMedicalHeader: formatMessage(messages.patientMedicalHeader),
    heightFtLabel: formatMessage(messages.heightFtLabel),
    heightInLabel: formatMessage(messages.heightInLabel),
    weightLbsLabel: formatMessage(messages.weightLbsLabel),
    wearingDeviceHeader: formatMessage(messages.wearingDeviceHeader),
    answerYes: formatMessage(messages.answerYes),
    answerNo: formatMessage(messages.answerNo),
    authErrorMessage: formatMessage(messages.authErrorMessage),
  };
};

export default useTranslations;
